import { ArticleTypeManager } from '../manager/article-type.manager';
import { ArticleCollectionVO, ArticleVO } from '@article/model/vo/article.vo';
import { ArrayUtils } from '@shared/util/array-utils';
import { UserModel } from '@user/model/user.model';
import { ArticleCollectionUtils } from '@article/util/article-collection-utils';
import { Observable, of } from 'rxjs';

export class FavoriteArticlesFilter {

  private _favoriteArticleIds: number[] = [];
  private _resultElectedArticleIds: number[] = [];

  constructor(private userModel: UserModel, private articleTypeManager: ArticleTypeManager) {
    this.updateFavoriteArticles();
  }

  public updateFavoriteArticles(): void {
    if (this.userModel.userProfile) {
      const favoriteArticleCollection: ArticleCollectionVO = ArticleCollectionUtils.getArticleCollectionByType(
        this.userModel.userProfile.articleCollections, ArticleCollectionVO.TYPE_FAVORITES);
      if (favoriteArticleCollection) {
        this._favoriteArticleIds = favoriteArticleCollection.articleIds;
      }
    }
  }

  public set resultElectedArticleIds(value: number[]) {
    this._resultElectedArticleIds = value;
  }

  public get resultElectedArticleIds(): number[] {
    return this._resultElectedArticleIds;
  }

  public loadFavoriteTypeIds(): Observable<number[]> {
    if (this._favoriteArticleIds.length > 0) {
      return this.articleTypeManager.retrieveArticleTypeIdsByArticleIds(this._favoriteArticleIds);
    } else {
      return of([]);
    }
  }

  private getTypeIdsOfFavoriteArticles(articles: ArticleVO[]): number[] {
    if (ArrayUtils.isEmpty(articles)) {
      return [];
    }
    const favoriteTypeIds: number[] = [];
    for (const article of articles) {
      if (!article.type || this._favoriteArticleIds.indexOf(article.identity) === -1) {
        continue;
      }
      if (favoriteTypeIds.indexOf(article.type.id) === -1) {
        favoriteTypeIds.push(article.type.id);
      }
    }
    return favoriteTypeIds;
  }

  public storeFavoriteArticle(article: ArticleVO): void {
    const favoriteArticleTypeIds = this.articleTypeManager.getDistinctArticleTypeIdsByArticleIds(this._favoriteArticleIds);
    if (this._favoriteArticleIds.indexOf(article.identity) >= 0) {
      return;
    }
    this._favoriteArticleIds.push(article.identity);
    if (article.type) {
      if (favoriteArticleTypeIds.indexOf(article.type.id) === -1) {
        favoriteArticleTypeIds.push(article.type.id);
      }
      this.articleTypeManager.addArticleTypeIdForArticleId(article.identity, article.type.id);
      if (ArrayUtils.isEmpty(this._resultElectedArticleIds)) {
        this._resultElectedArticleIds = [article.identity];
      } else {
        this._resultElectedArticleIds.push(article.identity);
      }
    }
  }

  public getFavoriteArticleIds(): number[] {
    return this._favoriteArticleIds;
  }

  public filterArticles(articles: ArticleVO[]): ArticleVO[] {
    if (ArrayUtils.isEmpty(articles)) {
      return [];
    }
    const articleTypeIdsToFilter: number[] = this.getTypeIdsOfFavoriteArticles(articles);
    const filteredArticles: ArticleVO[] = [];
    for (const article of articles) {
      if (!article.type) {
        continue;
      }
      if (articleTypeIdsToFilter.indexOf(article.type.id) === -1 || this._favoriteArticleIds.indexOf(article.identity) >= 0) {
        filteredArticles.push(article);
      }
    }
    return filteredArticles;
  }
}
